module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exportAll":"Export all fields","exportAdditional":"Export additional fields"}}')
  delete Component.options._Ctor
}
